"use strict";

exports.__esModule = true;

var Metrics_1 = require("./Metrics");

var Log_1 = require("../Log");

var KMTrackerENV;

(function (KMTrackerENV) {
  KMTrackerENV["Prod"] = "prod";
  KMTrackerENV["Test"] = "test";
})(KMTrackerENV = exports.KMTrackerENV || (exports.KMTrackerENV = {}));

var KonturMetricsAppender =
/** @class */
function () {
  function KonturMetricsAppender(_a) {
    var url = _a.url,
        projectName = _a.projectName;
    this.log = Log_1.LogManager.getLog(Metrics_1.LOG_PREFIX + "KMAppender");
    this.projectName = projectName;
    this.initKM(url);
  }

  KonturMetricsAppender.prototype.append = function (_a) {
    var category = _a.category,
        action = _a.action,
        label = _a.label,
        value = _a.value; // @ts-ignore

    window[this.projectName + "Queue"].push(['trackEvent', category, action, label, value]);
  };

  KonturMetricsAppender.prototype.initKM = function (url) {
    try {
      var script = document.createElement('script');
      script.async = true;
      script.src = url;
      script.defer = true;
      script.type = 'text/javascript';
      var firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    } catch (e) {
      this.log.error("Can't init kontur metrics " + e.message);
    } // @ts-ignore


    window[this.projectName + "Queue"] = [];
  };

  return KonturMetricsAppender;
}();

exports.KonturMetricsAppender = KonturMetricsAppender;